import styled, { css } from 'styled-components'

const Wrapper = styled.div`
  padding: ${(props) => (props.wrapperPadding >= 0 ? props.wrapperPadding : 15)}px;

  ${(props) =>
    props.hasBorderTop &&
    css`
      border-top: 1px solid ${props.theme.color_grey_mid};
    `}

  ${(props) =>
    props.hasBorderBottom &&
    css`
      border-bottom: 1px solid ${props.theme.color_grey_mid};
    `}
`

const Title = styled.span`
  && {
    margin: 0;
  }
`

const Button = styled.button`
  display: flex;
  position: relative;
  width: 100%;
  border: none;
  margin: 0;
  padding: 0;
  overflow: visible;
  background: transparent;
  color: inherit;
  -webkit-font-smoothing: inherit;
  -moz-osx-font-smoothing: inherit;
  appearance: none;
  text-align: left;

  /* Disabled button style rules */
  ${(props) =>
    props.disabled &&
    css`
      cursor: not-allowed;
    `}
`
const ButtonLink = styled.button`
  display: block;
  border: none;
  margin-top: 6px;
  padding: 0;
  overflow: visible;
  background: transparent;
  appearance: none;
  text-align: left;

  color: ${(props) => props.theme.color_tertiary};
  font-family: ${(props) => props.theme.font_family};
  font-weight: ${(props) => props.theme.font_weight_bold};
  font-size: ${(props) => props.theme.font_size_base};
  line-height: ${(props) => props.theme.line_height_base};
  text-decoration: underline;

  &:hover,
  &:active,
  &:focus {
    color: ${(props) => props.theme.color_tertiary_dark};
  }
`

const ButtonAll = styled(ButtonLink)`
  width: 100%;
  text-align: right;
  margin-bottom: 10px;
`

const Toggle = styled.span`
  position: absolute;
  right: 0;
  top: 2px;
  cursor: pointer;
  transition: 0.2s ease;

  ${(props) =>
    props.isOpen &&
    css`
      top: -2px;
      transform: rotate(180deg);
    `}
`

const Container = styled.div`
  overflow: hidden;

  ${(props) =>
    css`
      max-height: ${props.maxHeight};
      font-family: ${props.theme.font_family};
      font-size: ${props.theme.font_size_base};
    `}

  ${(props) =>
    !props.noAnimation &&
    css`
      transition: max-height 0.2s ease-out;
    `}
`

const InnerContainer = styled.div`
  margin-top: ${(props) => (props.titleBodySpacing >= 0 ? props.titleBodySpacing : 15)}px;
`
export { Wrapper, Title, Button, ButtonLink, ButtonAll, Toggle, Container, InnerContainer }
